import { createFileRoute } from '@tanstack/react-router';
import { TrustLayout } from '../../components/trust/TrustLayout';

export const Route = createFileRoute('/trust/')({
  component: TrustOverview,
});

function TrustOverview() {
  return (
    <TrustLayout>
      <h1 className="mt-0 text-2xl text-black">Trust at Repancy</h1>
      <p className="max-w-[720px] text-sm leading-relaxed text-black">
        Repancy is a legal AI prompt lab that integrates deeply with Microsoft 365
        and SharePoint. We treat your matter data as confidential by default and
        designed the integration so you can audit exactly what we read, what we
        write, and where it lives.
      </p>
      <p className="max-w-[720px] text-sm leading-relaxed text-black">
        The pages on the left explain the architecture, data residency, your
        Entra permissions, the audit log we write, and a live sandbox you can
        run against your own tenant to verify the integration is real.
      </p>
      <ul className="text-sm leading-loose text-black">
        <li><strong>Architecture</strong> — how Repancy talks to Microsoft Graph</li>
        <li><strong>Data residency</strong> — where caches live; what stays in your tenant</li>
        <li><strong>Your permissions</strong> — the real Entra roles + SharePoint sites you have (signed-in)</li>
        <li><strong>Audit log</strong> — every Graph write we make on your behalf (signed-in)</li>
        <li><strong>Sandbox</strong> — six safe Graph operations you can run live (signed-in)</li>
      </ul>
    </TrustLayout>
  );
}
